<template>
  <input
    v-bind="$attrs"
    :value="value"
    :checked="isChecked"
    type="checkbox"
    class="h-20 w-20 cursor-pointer"
    @change="onChange"
  >
</template>


<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'change',
  },
  props: {
    modelValue: {
      type: [Boolean, Array],
      default: false,
    },
    value: {
      type: [Boolean, String, Array],
      default: '',
    },
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) return this.modelValue.includes(this.value);

      return this.modelValue;
    },
  },
  methods: {
    onChange() {
      let modelValue = (typeof this.modelValue === 'object') ? this.modelValue.slice() : this.modelValue;

      if (Array.isArray(this.modelValue)) {
        if (modelValue.includes(this.value)) modelValue.splice(modelValue.indexOf(this.value), 1);
        else modelValue.push(this.value);
      } else {
        modelValue = !this.modelValue;
      }

      this.$emit('change', modelValue);
    },
  },
};
</script>
